<template>
  <div class="member-badge-item-parts">
    <i class="member-badge-item-parts__badge">
      <badge-year-parts v-if="badge.badgeType === 'year'" :badge="badge" />
      <badge-image-parts v-else :badge="badge" />
    </i>

    <img
      v-if="badge.badgeType === 'supporter'"
      class="member-badge-item-parts__logo"
      :src="require('@/assets/img/common/logo_dark.svg')"
      alt=""
    />

    <span class="member-badge-item-parts__label" v-text="badge.label" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import BadgeImageParts from '@/components/MypageTopPage/MembershipCardPane/parts/BadgeImageParts.vue'
import BadgeYearParts from '@/components/MypageTopPage/MembershipCardPane/parts/BadgeYearParts.vue'

export type BadgeData = {
  badgeType: 'year' | 'supporter'
  label?: string
  years?: number
}

/**
 * マイページ: 会員証 バッヂアイテムパーツ
 */
export default defineComponent({
  name: 'MemberBadgeItemParts',
  components: {
    BadgeYearParts,
    BadgeImageParts,
  },
  props: {
    badge: {
      type: Object as PropType<BadgeData>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.member-badge-item-parts {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 3px 10px 3px 36px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 34px;
  color: $white;
  font-family: $fontSignup;
  font-weight: 700;
  font-size: 10px;
  line-height: 2;
  letter-spacing: 0.02em;
  font-feature-settings: 'palt' on;
  white-space: nowrap;

  &__badge {
    position: absolute;
    left: 10px;
    top: 0;
  }

  &__logo {
    margin-right: 2px;
  }
}
</style>
